import { FilesDialog } from "#promotions/components/files/Files"
import { usePromotionsContext } from "#promotions/PromotionContext"
import VacancyFormDialog from "#vacancy/components/vacancy-form/VacancyFormDialog"
import { createContext, useContext, useMemo, useState } from "react"

export const ContextPromotionColaborador = createContext()

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {Object} props.detail
 * @param {int} props.detailId
 * @param {int} props.promotionId
 */
export function ContextPromotionColaboradorProvider({ detail, promotionId, children }) {
	const [openVacante, setOpenVacante] = useState(false)
	const [openFiles, setOpenFiles] = useState(false)
	const [reloadFiles, setReloadFiles] = useState(false)
	const { reload } = usePromotionsContext()

	const datos = useMemo(
		() => ({
			detail,
			detailId: detail?.id,
			promotionId,
			openVacante,
			setOpenVacante,
			openFiles,
			setOpenFiles,
			reloadFiles,
			refreshFiles: () => setReloadFiles((prev) => !prev),
		}),
		[detail, promotionId, openVacante, openFiles, reloadFiles],
	)

	return (
		<ContextPromotionColaborador.Provider value={datos}>
			{children}
			<FilesDialog />
			<VacancyFormDialog
				refresh={reload}
				open={openVacante}
				setOpen={setOpenVacante}
				defaultValues={{
					sucursal: detail?.sucursal_id,
					perfil_puesto: detail.old_profile_id,
					tipo_vacante: "Promoción",
					colaborador: detail?.colaborador,
					promotion: detail?.promotion,
					jefe_directo: detail?.authorization,
					promotion_detail: detail?.id,

					// ...detail,
				}}
				promotion
			/>
		</ContextPromotionColaborador.Provider>
	)
}

/**
 * @typedef {Object} ContextType
 * @property {Object} detail
 * @property {int} detailId
 * @property {int} promotionId
 * @property {boolean} openVacante
 * @property {function} setOpenVacante
 * @property {boolean} openFiles
 * @property {function} setOpenFiles
 * @property {boolean} reloadFiles
 * @property {function} refreshFiles
 */

/**
 * @returns {ContextType}
 */
export function UseContextPromotionColaborador() {
	return useContext(ContextPromotionColaborador)
}
